export const LOCALE_CODE = {
  CHINESE_CHINA: 'zh-CN',
  CHINESE_TAIWAN: 'zh-TW',
  ENGLISH_CANADA: 'en-CA',
  ENGLISH_UNITED_STATES: 'en-US',
  FILIPINO_PHILIPPINES: 'fil-PH',
  FRENCH_CANADA: 'fr-CA',
  JAPANESE_JAPAN_: 'ja-JP',
  JAPANESE_JAPAN_NON_STANDARD: 'ja-JA', // TODO: we should probably be removing this
  KOREAN_KOREA: 'ko-KR',
  RUSSIAN_RUSSIA: 'ru-RU',
  SPANISH_SPAIN: 'es-ES',
  VIETNAMESE_VIETNAM: 'vi-VN'
};
